import { render, staticRenderFns } from "./comprador.vue?vue&type=template&id=8a2b045e"
import script from "./comprador.vue?vue&type=script&lang=js"
export * from "./comprador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports